/**
 * Application route paths - centralized for consistency.
 */
export const ROUTES = {
  LOGIN: '/login',
  MFA: '/mfa',
  SEARCH: '/search',
  CUSTOMER: '/customer',
  BENEFIT_UPDATE: '/benefit/update',
  USAGE_HISTORY: '/usage-history',
  ERROR: '/error',
  ADMIN_USERS: '/admin/users',
  ADMIN_BENEFIT_HISTORY: '/admin/reports/benefit-history',
  ADMIN_AUDIT: '/admin/reports/audit',
  ADMIN_PAYMENT_FILE: '/admin/payment-file',
  ADMIN_CALCULATOR: '/admin/calculator',
};
